// extracted by mini-css-extract-plugin
export default {"plum_details_coverage":"S2_DetailsCoverage_plum_details_coverage__yspk4","iframeMapId":"S2_DetailsCoverage_iframeMapId__fDkPa"};